export function timeToSeconds(time) {
  const parts = time.split(/:/).map((p) => parseInt(p));
  return (parts[0] * 60 * 60) + (parts[1] * 60) + parts[2];
}

export function secondsToTime(seconds) {
  const _seconds = seconds % 60;
  const _minutes = Math.floor(seconds / 60 % 60);
  const _hours = Math.floor(seconds / 3600 % 60);

  return String(_hours).padStart(2, '0') + ':' + String(_minutes).padStart(2, '0') + ':' + String(_seconds).padStart(2, '0');
}
